import { render } from "./RiControlPlay.vue?vue&type=template&id=37e201f4"
import script from "./RiControlPlay.vue?vue&type=script&lang=js"
export * from "./RiControlPlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiControlPlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37e201f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37e201f4', __exports__)) {
    api.reload('37e201f4', __exports__)
  }
  
  module.hot.accept("./RiControlPlay.vue?vue&type=template&id=37e201f4", () => {
    api.rerender('37e201f4', render)
  })

}


export default __exports__